import styled from "styled-components";

export const StandardContainer = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ContentContainer = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #dee5ef;
  border-radius: 5px;
  background-color: #fff;
`;

export const StandardRowContainer = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: space-between;
  justify-content: center;
`;

export const StretchRow = styled.div`
  width: 100%;
  max-width: 100vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
`;

export const SubmitButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 12px 6px;
  justify-content: space-between;
  width: 40%;
`;

interface VerticalSpacerProps {
  spacing: string;
}

export const VerticalSpacer = styled.div<VerticalSpacerProps>`
  padding-top: ${(props) => props.spacing};
`;
